module.exports = __webpack_public_path__ + "static/img/industries4.8fefebe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industries4.png
// module id = JxOm
// module chunks = 1